"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCoreServicesOrgUrl = exports.createCoreServicesOrgUrl = exports.getCoreServicesGeoName = exports.nonProductionDynamicsLocationCode = exports.unqOrgUrlPattern = exports.coreServicesOrgUrlPrefix = exports.CoreServicesGeoNamesMapping = void 0;
exports.CoreServicesGeoNamesMapping = {
    "crm": "us",
    "crm2": "br",
    "crm3": "ca",
    "crm4": "eu",
    "crm5": "as",
    "crm6": "au",
    "crm7": "jp",
    "crm8": "in",
    "crm9": "gov",
    "crm10": "preprod",
    "crm11": "uk",
    "crm12": "fr",
    "crm14": "za",
    "crm15": "ae",
    "crm16": "de",
    "crm17": "ch",
    "crm19": "no",
    "crm20": "sg",
    "crm21": "kr",
    "crm22": "se",
    "crmtest": "test" // TEST
};
exports.coreServicesOrgUrlPrefix = "https://m-";
exports.unqOrgUrlPattern = /http[s]*:\/\/[\w-]*-(crmtest|crm[\d]*).[\w.]*/;
exports.nonProductionDynamicsLocationCode = ["crm10", "crmtest"];
exports.getCoreServicesGeoName = function (dynamicsLocationCode) {
    var _a;
    return (_a = exports.CoreServicesGeoNamesMapping[dynamicsLocationCode]) !== null && _a !== void 0 ? _a : "";
};
exports.createCoreServicesOrgUrl = function (orgId, geoName) {
    return "https://m-" + orgId + "." + geoName + ".omnichannelengagementhub.com";
};
exports.isCoreServicesOrgUrl = function (orgUrl) {
    return orgUrl.startsWith(exports.coreServicesOrgUrlPrefix);
};
//# sourceMappingURL=CoreServicesUtils.js.map